<div class="tooltip" matTooltipPosition="below"
     [matTooltip]="params.valueFormatted"
     [matTooltipDisabled]="params.valueFormatted === GRID_EMPTY_VALUE">
  {{ params.valueFormatted }}
</div>
